import { FileSend } from "../fileHandler";
import { protoHandler } from "../proto";
import { encodeMessageChar } from "../utils";
import store from "../../store";
import { clearDraft } from "../../store/draft/actions";
import { resetRepliedMessages, sendDraft } from "../services";
import { MessageBuilder, MessageDetailType } from "./messageBuilder";
import { addRoomMessages } from "../../store/messages/actions";
import { setMessengerAttachment } from "../../store/messenger/actions";
import { CHARACTER_LIMIT, FILE_CHARACTER_LIMIT } from "../../constants/globals";
import { MessageConcreteObserver } from "./messageConcreteObserver";
import { LargeTextObserverObserver } from "./observer/largeTextObserver";

function getSlicedMessage(message: string) {
  return message?.slice(0, CHARACTER_LIMIT);
}
export class MessageFacade {
  public messageDetail: MessageDetailType;
  public fakeMessage: MessageBuilder;

  constructor(messageDetail: MessageDetailType) {
    this.messageDetail = messageDetail;
    this.fakeMessage = new MessageBuilder(messageDetail.message);
  }

  async createFakeMessage() {
    if (!this.messageDetail) return;
    const fakeMessage = await this.fakeMessage.getResponse();
    store.dispatch(
      addRoomMessages({
        roomId: fakeMessage.roomId,
        messageList: [{ ...fakeMessage, message: getSlicedMessage(fakeMessage.message) }],
      })
    );
    store.dispatch(setMessengerAttachment(undefined));
    await this.reset();
  }

  async beforeSendMessage() {
    const attachmentFile = this.messageDetail?.message.attachment;
    await this.createFakeMessage();
    if (attachmentFile instanceof FileSend) {
      attachmentFile.onFileSaved(() => {
        this.createFakeMessage().then();
      });
      const messageTextTemp = this.messageDetail?.message.message as string;
      attachmentFile?.onFinish((token) => {
        this.messageDetail!.message.message = messageTextTemp?.substr(0, FILE_CHARACTER_LIMIT);
        this.messageDetail.message.attachment = token;
        this.sendMessage().then((e) => {
          this.afterSendMessage();
          this.fakeMessage = new MessageBuilder(e as any);
          this.createFakeMessage();
        });
        this.reset();
      });
      attachmentFile.start();
    } else await this.createFakeMessage();
  }

  async sendMessage() {
    const { actionId, message } = this.messageDetail;
    return protoHandler(actionId, {
      ...message,
      message: encodeMessageChar(getSlicedMessage(message.message)),
    });
  }

  private afterSendMessage() {
    this.messageDetail.message.attachment = undefined;
    const largeFileObserver = new LargeTextObserverObserver(this.messageDetail);
    const observer = new MessageConcreteObserver();
    observer.attach(largeFileObserver);
    return observer.handleSendConcrete();
  }

  reset() {
    store.dispatch(clearDraft(this.messageDetail?.roomId));
    resetRepliedMessages();
  }

  async handle() {
    await this.beforeSendMessage();
    await this.sendMessage();
    await this.afterSendMessage();
  }
}
